export default {
    SET_TUTORIALS(state, tutorials) {
        state.items = { ...tutorials };
    },

    UPDATE_TUTORIALS(state, tutorials) {
        state.items = { ...state.items, ...tutorials };
    },
};
